import { afterAttack, afterEvent, cardRef, defineGameCard } from '../authoring/index.js';
import { adultTreeDeathLeaf, growthOf, isLiveOnBoard, PLANT_GROWTH_ID, photosynthesis, removeGrowth, tableOf, } from './plant-helpers.js';
export const MASS_DAMAGE_BONUS_KEY = 'massDamageBonus';
/**
 * Древний дуб после атаки наносит 2 массового урона остальным врагам локации.
 * Каждые потраченные 3 Роста навсегда увеличивают этот урон на 1.
 */
export const AncientOakCard = defineGameCard({
    id: 'ancient_oak',
    gameplay: {
        type: 'UNIT',
        cost: 3,
        baseStats: { attack: 10, health: 12 },
        traits: ['PLANT', 'TREE'],
    },
    presentation: {
        name: 'Древний дуб',
        description: 'После своей атаки наносит 2 урона каждой другой вражеской карте в этой локации. За каждые 3 Роста тратит их и навсегда увеличивает этот массовый урон на 1. Гибель: создайте Лист в этой ячейке.',
        glyph: {
            colors: ['#10213A', '#4A6D39', '#204A2C', '#593922', '#764A29'],
            rows: [
                '........1111........',
                '......11222211......',
                '.....1222222221.....',
                '....122222222221....',
                '..1113333223333111..',
                '.122233333333322221.',
                '.122222333333222221.',
                '.132222233332222231.',
                '12333333344333333331',
                '13333335455453333331',
                '13333334455443333331',
                '.133333355553333331.',
                '..1113355555533111..',
                '.....1145554411.....',
                '......15555451......',
                '.....145555551......',
                '.....1545554451.....',
                '....154554455451....',
                '....145541145551....',
                '.....1111..1111.....',
            ],
        },
    },
    role: 'auxiliary',
    dependencies: [cardRef('ancient_oak')],
    abilities: [
        ...photosynthesis(),
        afterEvent({
            event: 'EffectCounterChanged',
            run: {
                source: 'card_effect',
                dependencies: [cardRef(PLANT_GROWTH_ID)],
                run: (ctx, ...args) => {
                    const event = args[0];
                    const self = ctx.self;
                    if (!isLiveOnBoard(self)
                        || event.defId !== PLANT_GROWTH_ID
                        || event.key !== 'growth'
                        || event.scope.kind !== 'unit'
                        || event.scope.instanceId !== self.id)
                        return;
                    const increase = Math.floor(growthOf(ctx, self.id) / 3);
                    if (increase <= 0)
                        return;
                    const current = self.vars[MASS_DAMAGE_BONUS_KEY];
                    const currentBonus = typeof current === 'number' && Number.isSafeInteger(current) && current >= 0
                        ? current
                        : 0;
                    ctx.ops.setVar(MASS_DAMAGE_BONUS_KEY, currentBonus + increase);
                    removeGrowth(ctx, self.id, increase * 3, 'oak');
                },
            },
        }),
        afterAttack((ctx, event) => {
            const self = ctx.self;
            if (!isLiveOnBoard(self) || event.attackerId !== self.id)
                return;
            const rawBonus = self.vars[MASS_DAMAGE_BONUS_KEY];
            const bonus = typeof rawBonus === 'number' && Number.isSafeInteger(rawBonus) && rawBonus >= 0
                ? rawBonus
                : 0;
            const damage = 2 + bonus;
            const tableId = tableOf(self.cellId);
            const attackedId = event.target.kind === 'unit' ? event.target.instanceId : undefined;
            const opponentId = ctx.q.opponentOf(self.controllerId).id;
            for (const enemy of ctx.q.unitsOf(opponentId)) {
                if (enemy.id === attackedId || enemy.cellId === undefined)
                    continue;
                if (tableOf(enemy.cellId) !== tableId)
                    continue;
                ctx.ops.dealDamage({ kind: 'unit', instanceId: enemy.id }, damage);
            }
        }),
        adultTreeDeathLeaf(),
    ],
    ui: {
        mechanics: ['growth', 'photosynthesis', 'death', 'token'],
        publicVars: { massDamageBonus: { key: MASS_DAMAGE_BONUS_KEY, kind: 'number' } },
        statusProviders: [(context) => {
                const bonus = context.card.facts.massDamageBonus;
                return typeof bonus === 'number' && bonus > 0
                    ? [{
                            id: 'ancient-oak-mass-damage',
                            symbol: `⚔${2 + bonus}`,
                            label: `Массовый урон ${2 + bonus}`,
                            description: `После атаки Древний дуб наносит ${2 + bonus} урона каждой другой вражеской карте в локации.`,
                            tone: 'positive',
                            compact: true,
                        }]
                    : [];
            }],
    },
});
//# sourceMappingURL=ancient_oak.js.map